import React from 'react';
import { Alert, AlertTitle, Link, Box } from '@mui/material';
import Signup from '@pages/Signup/Signup';
import config from '@configFile';

const LimitMessage = ({
  needsEmailVerification
}: {
  needsEmailVerification?: boolean;
}) => {
  return (
    <Alert severity="warning" style={{ margin: '12px 0' }}>
      <AlertTitle>Limit Reached</AlertTitle>
      As you are not a logged in user with a verified email address, your search
      is limited to {config.NON_USER_VARIATIONS_LIMIT} variations per search.
      This search has reached the limit and you will not see more than{' '}
      {config.NON_USER_VARIATIONS_LIMIT} variations. Please{' '}
      <Link href="/login" color="primary">
        login
      </Link>
      {` or verify your email address to see more. `}
      <Link href="/signup" color="primary">
        User accounts are free
      </Link>{' '}
      and have no limits.
      {!needsEmailVerification ? (
        <Box
          sx={{
            maxWidth: '400px',
            margin: '16px auto'
          }}
        >
          <Signup onlyShowOneButton refreshOnLogin />
        </Box>
      ) : null}
    </Alert>
  );
};

export default LimitMessage;
